/**
 * Minimal className joiner to avoid adding a dependency.
 * Accepts strings, falsy values, arrays, and simple `{ className: boolean }` maps.
 */
export function cx(...parts) {
  const out = [];
  for (const part of parts) {
    if (!part) continue;
    if (typeof part === 'string') {
      out.push(part);
      continue;
    }
    if (Array.isArray(part)) {
      out.push(cx(...part));
      continue;
    }
    if (typeof part === 'object') {
      for (const [k, v] of Object.entries(part)) {
        if (v) out.push(k);
      }
    }
  }
  return out.filter(Boolean).join(' ');
}

